import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import styled from 'styled-components';
import { GREAT_WHITE, OBSIDIAN, OLAF } from 'HubStyleTokens/colors';
import ContactAvatar from './ContactAvatar';
import TicketName from './TicketName';
import ContactInformation from './ContactInformation';
import TicketInformation from './TicketInformation';
import { getContactLink, getCompanyLink } from '../../../external-urls/public';
import { getTicketId } from 'conversations-thread-data/tickets/public/operators';
import { getTicketRecordLink } from '../operators/getTicketRecordLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIMediaObject = styled(UIMediaObject).withConfig({
  displayName: "TicketHeader__StyledUIMediaObject",
  componentId: "iuvf2e-0"
})(["width:'min-content';"]);
const StyledUIFlex = styled(UIFlex).withConfig({
  displayName: "TicketHeader__StyledUIFlex",
  componentId: "iuvf2e-1"
})(["line-height:16px;font-size:14px;padding-top:3px;"]);
const DetailHeaderWrapper = styled.div.withConfig({
  displayName: "TicketHeader__DetailHeaderWrapper",
  componentId: "iuvf2e-2"
})(["height:60px;border-bottom:solid 1px ", ";background-color:", ";z-index:1;flex-shrink:0;"], GREAT_WHITE, OLAF);
const TicketHeader = ({
  children,
  contactEmail,
  contactDetail,
  company,
  associatedCompanyId,
  associatedCompanyName,
  isKnownContact,
  includeEschref,
  ticket,
  threadId,
  vid,
  trackEvent,
  renderAssociateContactButton
}) => {
  const stripCompanyName = companyName => {
    return companyName.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
  };
  const shouldMatchCompany = associatedCompanyId && stripCompanyName(company) === stripCompanyName(associatedCompanyName) || company === '' && associatedCompanyName !== '';
  const companyLink = shouldMatchCompany ? getCompanyLink(associatedCompanyId) : '';
  const contactLink = getContactLink(vid);
  return /*#__PURE__*/_jsxs(DetailHeaderWrapper, {
    role: "heading",
    "aria-level": 1,
    className: "display-flex p-x-4 p-y-2",
    children: [/*#__PURE__*/_jsx(UIBox, {
      className: "m-right-3 m-y-1",
      shrink: 0,
      children: /*#__PURE__*/_jsx(ContactAvatar, {
        isKnownContact: isKnownContact,
        email: contactEmail,
        contactDetail: contactDetail,
        vid: vid,
        threadId: threadId
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      basis: "100%",
      grow: 1,
      className: "p-right-6",
      children: /*#__PURE__*/_jsxs(StyledUIMediaObject, {
        className: "flex-column",
        children: [/*#__PURE__*/_jsx(UIFlex, {
          children: /*#__PURE__*/_jsx(TicketName, {
            includeEschref: includeEschref,
            ticketId: getTicketId(ticket),
            ticketName: ticket.defaultProperties.subject.value,
            ticketRecordLink: getTicketRecordLink(ticket),
            linkColor: OBSIDIAN,
            trackEvent: trackEvent,
            useFlex: true
          })
        }), /*#__PURE__*/_jsxs(StyledUIFlex, {
          direction: "row",
          children: [/*#__PURE__*/_jsx(ContactInformation, {
            associatedCompanyId: associatedCompanyId,
            contactDetail: contactDetail,
            contactLink: contactLink,
            companyName: company || associatedCompanyName,
            companyLink: companyLink,
            includeEschref: includeEschref,
            isKnownContact: isKnownContact,
            renderAssociateContactButton: renderAssociateContactButton,
            vid: vid,
            trackEvent: trackEvent,
            truncate: true,
            truncateStringProps: {
              maxWidth: '20vw'
            }
          }), /*#__PURE__*/_jsx(TicketInformation, {
            ticketId: ticket.defaultProperties.hs_ticket_id.value,
            createDate: ticket.defaultProperties.createdate.value,
            closeDate: ticket.defaultProperties.closed_date.value,
            trackEvent: trackEvent
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      className: "align-center justify-end p-y-2",
      shrink: 0,
      children: children
    })]
  });
};
TicketHeader.displayName = 'TicketHeader';
export default TicketHeader;